<template>
    <div>
        <base-dropdown :position="'right'">
            <template slot="title">
                <div class="media align-items-center custom-media-nav-size" slot="title">
                    <i class="fas fa-copyright text-color-wallet"></i>
                    <div :class="['media-body ml-2 d-none d-md-block d-lg-block pr-1', { 'text-color-wallet': !loadWallet }]">
                        <span v-bind:style="{color: this.$THEME.primaryColor}" :class="(this.$THEME.primaryColor?'':'text-blue')" v-if="loadWallet">
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                        <span class="mb-0 text-sm font-weight-bold color-text-li" v-else> 
                            {{$WALLET.available_balance | numFormat('0,0.00')}}
                            <p class="mb-0 small text-right">เครดิต</p>
                        </span>
                    </div>
                </div>
            </template>
            <template v-if="this.$USER_LOGIN.get().isAdmin">
                <router-link to="/topupcredit" class="dropdown-item">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิต</span>
                </router-link>
                <router-link to="/history/topupwallet" class="dropdown-item">
                    <i class="fas fa-file-alt" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                    <span>ประวัติเติมเครดิต</span>
                </router-link>
                <router-link to="/history/usagewallet" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งาน</span>
                </router-link>
            </template>
            <template v-if="this.$USER_LOGIN.get().isSuperadmin">
                <router-link to="/topupcredit/shop" class="dropdown-item" v-if="this.$THEME.manageVision.menuTopUpCreditSA">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิตให้สาขา</span>
                </router-link>
                <router-link to="/history/topupcredit/superadmin" class="dropdown-item">
                    <Icon icon="mdi-file-document" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติเติมเครดิตของสาขา</span>
                </router-link>
                <router-link to="/history/usagewallet/superadmin" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งานเครดิต</span>
                </router-link>
                <a 
                    class="dropdown-item"
                    @click="withDrawCredit.show = true" >
                    <Icon icon="mdi-notebook-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    ถอนเครดิต
                </a>
            </template>
        </base-dropdown>
        <ModalWithDrawCredit :withDrawCredit="withDrawCredit" />
    </div>
</template>

<script>
import ModalWithDrawCredit from '@/components/Modals/ModalWithDrawCredit'
import { walletPayment } from "@/axios/walletPayment.js"

export default {
    name:"DropDownWallet",
    components:{
        ModalWithDrawCredit
    },
    data() {
        return {
            withDrawCredit:{
                show: false
            },
            loadWallet: true
        }
    },
    mounted(){
        walletPayment().then( res => {
            this.$WALLET.available_balance = res.available_balance
            this.$WALLET.balance = res.balance
            this.$WALLET.peg_balance = res.peg_balance
            this.loadWallet = false
        })
    }
}
</script>
